module.exports = __webpack_public_path__ + "img/character06_static.d4268f41.png";